import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { Searchgeneral } from 'src/app/model/searchgeneral.model';
import { UserService } from 'src/app/services/user/user.service';
import { NgForm } from '@angular/forms';
import { RoleService } from 'src/app/services/role/role.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ResetButtonRendererComponent } from 'src/app/resetbutton-renderer.component';
import * as fileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { Createproject } from 'src/app/model/createproject.model';
import { ExportButtonRendererComponent } from 'src/app/exportbutton-renderer.component';
import { SentryapibuttonRendererComponent } from 'src/app/sentryapibutton-renderer.component';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';


@Component({
  selector: 'app-projectinfo',
  templateUrl: './projectinfo.component.html',
  styleUrls: ['./projectinfo.component.css']
})
export class ProjectinfoComponent implements OnInit, AfterViewInit, OnDestroy {

  /****
    Hide Red color alert box which showing message:
   "This CKEditor 4.16.0 version is not secure. Consider upgrading to the latest one4.25.1-lts."
  ******* */
  private observer: MutationObserver;

  ngAfterViewInit(): void {
    this.observer = new MutationObserver(() => {
      const el = document.querySelector('.cke_notifications_area') as HTMLElement;
      if (el) {
        el.style.display = 'none';
      }
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  /**************************************************************** */

  hours: number[] = Array.from({ length: 12 }, (_, i) => i + 1); // 1 to 12
  minutes: string[] = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0')); // 00 to 59
  ampm: string[] = ['AM', 'PM'];

  test1: string;
  customMessage: any;
  test: string;
  projectDetails: any;
  ckeditorContent: string;
  multipleBool: boolean = false;
  roleId: string;
  isSurveyDataExist: boolean = false;
  remainUnassignedLinks: number = 0;
  isVendorDetailsExist: boolean = false;
  isVendorDetailsHitReportExist: boolean = false;
  rowData: any;
  rowDataForMultiple: any;
  rowDataNew: any;
  rowDataCount: any;
  private gridApi;
  private gridColumnApi;
  project: Createproject;
  frameworkComponents: any
  isDataLoading: boolean = false;
  dropdownSettingTeamMember = {};
  dataTeamMember: any;

  projectNameForSentry: string = "";
  exevoLinkForSentry: string = "";
  // countryForSentry: string = '';
  // languageForSentry: string = '';
  sentryTemplates: any[] = [];
  selectedTemplateId: string = '';

  assignedClipForSentry: string = "";
  protectIdForSentry: string = "";
  VendorNameForSentry: string = "";
  VendorIdForSentry: string = "";
  sentryProjectData: any[] = [];
  sentryExistingProjectId: string = "";

  sentryTerminationURL: string = "";

  countryData: any;
  data: any;
  dataL: any;
  languageData: any;

  // Selected countries
  countryForSentry: any[] = [];

  // Selected languages
  languageForSentry: any[] = [];

  // Country dropdown settings
  dropdownSettingCountry = {
    singleSelection: false,
    idField: 'code',
    textField: 'countryName',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 5,
    allowSearchFilter: true,
    closeDropDownOnSelection: false
  };

  // Language dropdown settings
  dropdownSettingLanguage = {
    singleSelection: false,
    idField: 'code',
    textField: 'language',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 5,
    allowSearchFilter: true,
    closeDropDownOnSelection: false
  };

  columnDefs = [
    { headerName: "Country Name(s)", field: "countryName", filter: true, sortable: true, resizable: true, maxWidth: 138 },
    { headerName: "Language(s)", field: "language", filter: true, sortable: true, resizable: true, maxWidth: 190 },
    { headerName: "Vendor Name", field: "vendorName", filter: true, sortable: true, resizable: true, maxWidth: 275 },
    { headerName: "Assigned Clip(s)", field: "clip", filter: true, sortable: true, resizable: true, maxWidth: 275 },
    { headerName: "Survey Link", field: "clientLink", resizable: true },
    { headerName: "Target", field: "target", resizable: true, maxWidth: 120, editable: true },
    { headerName: "Optimistic Count", field: "optimisticCount", resizable: true, maxWidth: 130, editable: true },
    {
      headerName: 'Re-set Target',
      cellRenderer: 'buttonRenderer',
      maxWidth: 138,
      cellRendererParams: {
        onClick: this.ResetData.bind(this),
        label: 'Reset'
      },
    },

  ];

  columnDefsForMultiple = [
    { headerName: "Country Name(s)", field: "countryName", filter: true, sortable: true, resizable: true },
    { headerName: "Language(s)", field: "language", filter: true, sortable: true, resizable: true },
    { headerName: "Vendor Name", field: "vendorName", filter: true, sortable: true, resizable: true, maxWidth: 275 },
    { headerName: "Assigned Clip(s)", field: "clip", filter: true, sortable: true, resizable: true, maxWidth: 275 },
    { headerName: "Target", field: "target", resizable: true, editable: true },
    { headerName: "Optimistic Count", field: "optimisticCount", resizable: true, editable: true },
    { headerName: "ClientLink Key", field: "ClientLinkKey", resizable: true, editable: true, hide: true },

    {
      headerName: 'Re-set Target',
      cellRenderer: 'buttonRenderer',
      maxWidth: 138,
      cellRendererParams: {
        onClick: this.ResetData.bind(this),
        label: 'Reset'
      },
    },
    {
      headerName: 'Export',
      cellRenderer: 'exportButtonRenderer',
      maxWidth: 138,
      cellRendererParams: {
        onClick: this.exportLinksMultiple.bind(this),
        label: 'Export'
      },
    },

  ];

  columnDefsNew = [
    { headerName: "Vendor ID", field: "vendorId", hide: true },
    { headerName: "Country Name(s)", field: "countryName", filter: true, sortable: true, resizable: true, maxWidth: 138 },
    { headerName: "Language(s)", field: "language", filter: true, sortable: true, resizable: true, maxWidth: 190 },
    { headerName: "Vendor Name", field: "vendorName", resizable: true, maxWidth: 138 },
    { headerName: "Assigned Clip(s)", field: "assignedClip", resizable: true, maxWidth: 120 },
    {
      headerName: "SurveyRedirectionDetails",
      cellRenderer: function (param) {
        return '<b>' + param.data.tag1 + '</b>' + ' ' + param.data.exevoLink
          + '<br/>' + '<b>' + param.data.tag2 + '</b>'
          + '<br/>' + '<b>' + param.data.tag3 + '</b>' + ' ' + param.data.vendorSC + '<br/>' + '<b>' + param.data.tag4 + '</b>' + ' ' + param.data.vendorST + '<br/>' + '<b>' + param.data.tag5 + '</b>' + ' ' + param.data.vendorSQF + '<br/>' + '<b>' + param.data.tag6 + '</b>' + ' ' + param.data.vendorSQCR
          + '<br/>' + '<b>' + param.data.tag9 + '</b>'
          + '<br/>' + '<b>' + param.data.tag7 + '</b>' + ' ' + param.data.testLink
          + '<br/>' + '<b>' + param.data.tag8 + '</b>' + ' ' + param.data.liveLink
          ;
      }
    },
    {
      headerName: 'Edit Country Check',
      cellRenderer: 'buttonRenderer',
      maxWidth: 138,
      cellRendererParams: {
        onClick: this.editCountryCheck.bind(this),
        label: 'Reset'
      },
    },
    {
      headerName: "Sentry API",
      cellRenderer: 'sentryApiButtonRenderer',
      maxWidth: 138,
      cellRendererParams: {
        onClick: this.SentryApi.bind(this),
        label: 'Sentry API'
      }
    },
  ];

  columnDefsCount = [
    { headerName: "Vendor ID", field: "vendorId", hide: true },
    { headerName: "Country Name(s)", field: "countryName", filter: true, sortable: true, resizable: true, maxWidth: 138 },
    { headerName: "Language(s)", field: "language", filter: true, sortable: true, resizable: true, maxWidth: 190 },
    { headerName: "Vendor Name", field: "vendorName", resizable: true, maxWidth: 138 },
    { headerName: "Assigned Clip(s)", field: "clip", resizable: true, maxWidth: 120 },
    { headerName: "Complete", field: "completeCount", resizable: true, maxWidth: 120 },
    { headerName: "Terminate", field: "terminateCount", resizable: true, maxWidth: 120 },
    { headerName: "Quota Full", field: "quotaFullCount", resizable: true, maxWidth: 120 },
    { headerName: "PET Quota Full", field: "petQuotaFull", resizable: true, maxWidth: 120 },
    { headerName: "Client Quota Full", field: "clientQuotaFull", resizable: true, maxWidth: 120 },
    { headerName: "QC Reject", field: "qcRejectCount", resizable: true, maxWidth: 120 },
    { headerName: "In Progress", field: "inProgressCount", resizable: true, maxWidth: 120 },
    // {
    //   headerName: "SurveyRedirectionDetails",
    //   cellRenderer: function (param) {
    //     return '<b>' + param.data.tag1 + '</b>' + ' ' + param.data.exevoLink
    //       + '<br/>' + '<b>' + param.data.tag2 + '</b>'
    //       + '<br/>' + '<b>' + param.data.tag3 + '</b>' + ' ' + param.data.vendorSC + '<br/>' + '<b>' + param.data.tag4 + '</b>' + ' ' + param.data.vendorST + '<br/>' + '<b>' + param.data.tag5 + '</b>' + ' ' + param.data.vendorSQF + '<br/>' + '<b>' + param.data.tag6 + '</b>' + ' ' + param.data.vendorSQCR
    //       + '<br/>' + '<b>' + param.data.tag9 + '</b>'
    //       + '<br/>' + '<b>' + param.data.tag7 + '</b>' + ' ' + param.data.testLink
    //       + '<br/>' + '<b>' + param.data.tag8 + '</b>' + ' ' + param.data.liveLink
    //       ;
    //   }
    // },
    // {
    //   headerName: 'Edit Country Check',
    //   cellRenderer: 'buttonRenderer',
    //   maxWidth: 138,
    //   cellRendererParams: {
    //     onClick: this.editCountryCheck.bind(this),
    //     label: 'Reset'
    //   },
    // },
    // {
    //   headerName: "Sentry API",
    //   cellRenderer: 'sentryApiButtonRenderer',
    //   maxWidth: 138,
    //   cellRendererParams: {
    //     onClick: this.SentryApi.bind(this),
    //     label: 'Sentry API'
    //   }
    // },
  ];

  columnDefsMultiple = [
    { headerName: "Country Name(s)", field: "countryName", filter: true, sortable: true, resizable: true, maxWidth: 138 },
    { headerName: "Language(s)", field: "language", filter: true, sortable: true, resizable: true, maxWidth: 190 },
    { headerName: "Vendor Name", field: "vendorName", resizable: true, maxWidth: 138 },
    { headerName: "Assigned Clip(s)", field: "assignedClip", resizable: true, maxWidth: 120 },
    {
      headerName: "SurveyRedirectionDetails",
      cellRenderer: function (param) {
        return '<b>' + param.data.tag3 + '</b>' + '<br/>' + param.data.vendorSC + '<br/>' + '<b>' + param.data.tag4 + '</b>' + '<br/>' + param.data.vendorST + '<br/>' + '<b>' + param.data.tag5 + '</b>' + '<br/>' + param.data.vendorSQF + '<br/>' + '<b>' + param.data.tag6 + '</b>' + '<br/>' + param.data.vendorSQCR;
      }
    },
    { headerName: "Assigned No.Of Links", field: "assignedLinks", resizable: true, maxWidth: 120 },
    {
      headerName: 'Edit Country Check',
      cellRenderer: 'buttonRenderer',
      maxWidth: 138,
      cellRendererParams: {
        onClick: this.editCountryCheck.bind(this),
        label: 'Reset'
      },
    },
    {
      headerName: 'Export',
      cellRenderer: 'exportButtonRenderer',
      maxWidth: 138,
      cellRendererParams: {
        onClick: this.exportLinks.bind(this),
        label: 'Export'
      },
    },

  ];
  rowHeight = 300;

  autoGroupColumnDef = {
    headerName: 'Select',
    field: 'select',
    minWidth: 250,
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: { checkbox: true },
  };
  defaultColDef = {
    flex: 1,
    minWidth: 100,
  };

  constructor(private userService: UserService, private router: Router, private roleservice: RoleService, private route: ActivatedRoute, private toastr: ToastrService) {
    this.roleId = this.route.snapshot.params.projectid;
    this.frameworkComponents = {
      buttonRenderer: ResetButtonRendererComponent,
      exportButtonRenderer: ExportButtonRendererComponent,
      sentryApiButtonRenderer: SentryapibuttonRendererComponent,
    }
  }

  ngOnInit() {
    //alert(this.roleId);
    this.getProjectInfo();
    // this.getSurveyLinkData();
    this.getVendorDetailsData();
    this.getProjectVendorStatusCounts();
    this.project = new Createproject();
    this.dropdownSettingTeamMember = {
      // singleSelection: true,
      idField: 'id',
      textField: 'fullName',
      allowSearchFilter: true,
      // closeDropDownOnSelection: true
    };
    this.getTeamMemberList();

    this.userService.getTeamMemberList().subscribe(() => {
      // Ensure all users are loaded before selecting team members
      this.userService.getAssignTeamsToProject(this.roleId).subscribe((data: any) => {
        if (data && Array.isArray(data)) {
          const selectedIds = data.map((member: any) => member.userID);

          // Ensure `dataTeamMember` has loaded before filtering
          setTimeout(() => {
            this.project.teamMember = this.dataTeamMember.filter(member => selectedIds.includes(member.id));
            console.log("Pre-selected team members:", this.project.teamMember);
          }, 500); // Small delay to ensure dataTeamMember is available
        }
      });
    });
    this.getLanguageList();
    this.getCountryList();
  }

  getTeamMemberList() {
    debugger;
    this.userService.getTeamMemberList().subscribe(
      (data) => {
        this.dataTeamMember = data;
        // this.dataL = this.languageData;
        //console.log("user data" + this.dataL);
      }
    )
  }
  getProjectInfo() {
    debugger;
    this.roleservice.SearchProjectInfo(this.roleId).subscribe(
      (data: any) => {
        if (data != null || data != undefined) {


          if (data[0].projectMode == "Production") {
            data[0].projectMode = "2";
          }
          else if (data[0].projectMode == "Staging" || data[0].projectMode == "Testing") {
            data[0].projectMode = "1";
          }
          this.customMessage = data[0].customPageMessage

          this.projectDetails = data;
          if (this.projectDetails.filter(s => s.clintLinkType == "multiple").length > 0) {
            this.multipleBool = true;
          }
          else {
            this.multipleBool = false;
          }
        }

        if (this.projectDetails.length === 0) {
        }
        else {


        }
        this.getSurveyLinkData();
        console.log(this.projectDetails);
      }
    )
  }

  exportLinks(param) {
    this.roleservice.exportLinks(param).subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
          const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
          const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
          this.saveAsExcelFile(excelBuffer, "Encrypted Links");
        }
      });
  }

  getSurveyLinkData() {
    if (!this.multipleBool) {
      this.roleservice.GetSurveyLinkData(this.roleId).subscribe(
        (data: any) => {
          debugger;
          if (data.length != 0) {
            this.isSurveyDataExist = true;
            this.rowData = data;
          }
          else {
            this.isSurveyDataExist = false;
          }
        }
      )
    }
    else if (this.multipleBool) {
      this.roleservice.GetSurveyLinkDataForMultiple(this.roleId).subscribe(
        (data: any) => {
          debugger;
          if (data.length != 0) {
            this.isSurveyDataExist = false;
            this.rowDataForMultiple = data;
          }
          else {

          }
        }
      )
    }
  }

  getVendorDetailsData() {
    debugger;
    this.roleservice.GetVendorDetailsData(this.roleId).subscribe(
      (data: any) => {
        this.rowDataNew = data;
        console.log(this.rowDataNew)
        if (data.length != 0) {
          debugger;
          this.isVendorDetailsExist = true;
          debugger;
          if (this.multipleBool) {
            for (var i = 0; i < this.rowDataNew.length; i++) {
              this.remainUnassignedLinks += this.rowDataNew[i].remainingLinks;
            }
          }
        }
        else {
          this.isVendorDetailsExist = false;
        }
      }
    )
  }

    getProjectVendorStatusCounts() {
    debugger;
    this.roleservice.getProjectVendorStatusCounts(this.roleId).subscribe(
      (data: any) => {
        this.rowDataCount = data;
        console.log(this.rowDataCount)
        if (data.length != 0) {
          debugger;
          this.isVendorDetailsHitReportExist = true;
          debugger;
          if (this.multipleBool) {
            for (var i = 0; i < this.rowDataCount.length; i++) {
              this.remainUnassignedLinks += this.rowDataCount[i].remainingLinks;
            }
          }
        }
        else {
          this.isVendorDetailsHitReportExist = false;
        }
      }
    )
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  // AddCountry() {
  //   this.router.navigate(['/createproject/' + this.roleId + "/" + this.projectDetails[0].projectName + "/" + this.projectDetails[0].clientName + "/" + this.projectDetails[0].projectDescription]);
  // }

  AddCountry() {
    this.router.navigate([
      '/createproject',
      this.roleId,
      encodeURIComponent(this.projectDetails[0].projectName),
      encodeURIComponent(this.projectDetails[0].clientName),
      encodeURIComponent(this.projectDetails[0].projectDescription),
      encodeURIComponent(this.projectDetails[0].proposalCode)
    ]);
  }

  // AddLanguage() {
  //   this.router.navigate(['/createproject/' + this.roleId + "/" + this.projectDetails[0].projectName + "/" + this.projectDetails[0].clientName + "/" + this.projectDetails[0].projectDescription]);
  // }

  AddLanguage() {
    this.router.navigate([
      '/createproject',
      this.roleId,
      encodeURIComponent(this.projectDetails[0].projectName),
      encodeURIComponent(this.projectDetails[0].clientName),
      encodeURIComponent(this.projectDetails[0].projectDescription),
      encodeURIComponent(this.projectDetails[0].proposalCode)
    ]);
  }

  getLanguageList() {
    debugger;

    this.userService.getLanguageList().subscribe(
      (data) => {
        this.languageData = data;
        this.dataL = this.languageData;
      }
    );
  }

  getCountryList() {
    debugger;

    this.userService.getCountryList().subscribe(
      (data) => {
        this.countryData = data;
        this.data = this.countryData;
      }
    );
  }

  SentryApi(params: any) {
    const rowData = params.data;

    const vendorSQCR = rowData.vendorSQCR;

    if (vendorSQCR) {
      this.sentryTerminationURL =
        vendorSQCR.replace(/\[RE\]/g, 'SENTRY_RESPONDENT_ID');
    }
    this.sentryExistingProjectId = '';
    this.projectNameForSentry = '';
    // this.countryForSentry = '';
    // this.languageForSentry = '';
    this.assignedClipForSentry = '';
    this.protectIdForSentry = '';
    this.VendorNameForSentry = '';
    this.VendorIdForSentry = '';
    this.exevoLinkForSentry = '';

    // Reset HTML ngModel values
    this.selectedTemplateId = '';
    this.enableVerisoul = false;
    this.fakeRespondentsAction = 'Term';
    this.suspiciousRespondentsAction = 'Term';
    this.addSentryStatusToUrl = false;

    // Get template
    if (!this.multipleBool) {
      this.userService.GetSentryTemplate().subscribe({
        next: (response: any) => {
          if (response.success && response.data) {
            this.sentryTemplates = response.data;
          }
        },
        error: (error) => {
          console.error('GetSentryTemplate error:', error);
        }
      });
    }

    this.userService.GetExistingSentryProjectId(rowData).subscribe({
      next: (responseData: any) => {
        console.log(
          'Existing project response:',
          responseData
        );

        if (
          responseData &&
          responseData.sentryProjectId &&
          responseData.sentryProjectId.trim() !== ''
        ) {

          // =====================================================
          // Existing project found
          // =====================================================

          this.sentryProjectData = responseData;

          this.sentryExistingProjectId =
            responseData.sentryProjectId;

          this.projectNameForSentry =
            responseData.name || '';

          // =====================================================
          // COUNTRY
          // =====================================================

          let countryValue =
            responseData.locationCodes ||
            responseData.LocationCodes ||
            '';

          console.log(
            'Saved country value:',
            countryValue
          );

          let countryCodes: string[] = [];

          if (Array.isArray(countryValue)) {
            for (let i = 0; i < countryValue.length; i++) {
              const values = String(countryValue[i]).split(',');
              for (let j = 0; j < values.length; j++) {
                const code = values[j].trim();
                if (code !== '') {
                  countryCodes.push(code);
                }
              }
            }
          } else {
            const values = String(countryValue).split(',');
            for (let i = 0; i < values.length; i++) {
              const code = values[i].trim();
              if (code !== '') {
                countryCodes.push(code);
              }
            }
          }

          console.log('Saved country codes:', countryCodes);

          // Match saved codes against dropdown data
          this.countryForSentry = [];

          if (
            this.data !== null &&
            this.data !== undefined &&
            this.data.length > 0
          ) {

            for (let i = 0; i < this.data.length; i++) {
              const country = this.data[i];
              if (
                country !== null &&
                country !== undefined &&
                country.code !== null &&
                country.code !== undefined
              ) {

                const dropdownCode =
                  String(country.code)
                    .trim()
                    .toLowerCase();

                for (let j = 0; j < countryCodes.length; j++) {

                  const savedCode =
                    String(countryCodes[j])
                      .trim()
                      .toLowerCase();

                  if (dropdownCode === savedCode) {
                    this.countryForSentry.push(country);
                    break;
                  }
                }
              }
            }
          }

          console.log(
            'Selected countries:',
            this.countryForSentry
          );

          // =====================================================
          // LANGUAGE
          // =====================================================

          let languageValue =
            responseData.languageCodes ||
            responseData.LanguageCodes ||
            '';

          console.log(
            'Saved language value:',
            languageValue
          );

          let languageCodes: string[] = [];

          if (Array.isArray(languageValue)) {

            for (let i = 0; i < languageValue.length; i++) {

              const values =
                String(languageValue[i]).split(',');

              for (let j = 0; j < values.length; j++) {

                const code =
                  values[j].trim();

                if (code !== '') {
                  languageCodes.push(code);
                }
              }
            }

          } else {

            const values =
              String(languageValue).split(',');

            for (let i = 0; i < values.length; i++) {

              const code =
                values[i].trim();

              if (code !== '') {
                languageCodes.push(code);
              }
            }
          }

          console.log(
            'Saved language codes:',
            languageCodes
          );

          // Match saved codes against dropdown data
          this.languageForSentry = [];

          if (
            this.dataL !== null &&
            this.dataL !== undefined &&
            this.dataL.length > 0
          ) {

            for (let i = 0; i < this.dataL.length; i++) {

              const language =
                this.dataL[i];

              if (
                language !== null &&
                language !== undefined &&
                language.code !== null &&
                language.code !== undefined
              ) {

                const dropdownCode =
                  String(language.code)
                    .trim()
                    .toLowerCase();

                for (let j = 0; j < languageCodes.length; j++) {

                  const savedCode =
                    String(languageCodes[j])
                      .trim()
                      .toLowerCase();

                  if (dropdownCode === savedCode) {

                    this.languageForSentry.push(language);

                    break;
                  }
                }
              }
            }
          }

          console.log(
            'Selected languages:',
            this.languageForSentry
          );

          // =====================================================
          // OTHER EXISTING PROJECT DATA
          // =====================================================

          this.assignedClipForSentry =
            responseData.clip || '';

          this.protectIdForSentry =
            responseData.projectId || '';

          this.VendorNameForSentry =
            responseData.vendorName || '';

          this.VendorIdForSentry =
            responseData.vendorId || '';

          // =====================================================
          // SENTRY SETTINGS
          // =====================================================

          this.selectedTemplateId =
            responseData.templateId || '';

          this.enableVerisoul =
            responseData.verisoulIsEnabled || false;

          this.fakeRespondentsAction =
            responseData.verisoulShouldTermFake
              ? 'Term'
              : 'Flag';

          this.suspiciousRespondentsAction =
            responseData.verisoulShouldTermSuspicious
              ? 'Term'
              : 'Flag';

          this.addSentryStatusToUrl =
            responseData.addStatusToUrl || false;

          // =====================================================
          // CLIENT URL
          // =====================================================

          const link =
            responseData.clientUrl || '';

          if (link !== '') {

            this.exevoLinkForSentry =
              link.replace(
                /\[RE\]/g,
                'SENTRY_RESPONDENT_ID'
              );

          } else {

            this.exevoLinkForSentry = '';
          }

          // =====================================================
          // OPEN MODAL
          // =====================================================

          $('#sentryAPIModal').show();

        } else {

          // =====================================================
          // No existing project
          // =====================================================

          this.getDataForSentryApi(rowData);
        }
      },

      error: (error: any) => {

        console.error(
          'GetExistingSentryProjectId error:',
          error
        );
      }
    });
  }

  private getDataForSentryApi(rowData: any) {
    console.log('Calling GetDataForSentryApi for row:', rowData);

    this.userService
      .GetDataForSentryApi(rowData, this.roleId)
      .subscribe({
        next: (response: any) => {

          console.log('C# GetDataForSentryApi response:', response);

          // =====================================================
          // GET DATA
          // =====================================================

          let data: any = rowData;

          if (
            response !== null &&
            response !== undefined &&
            response.success === true &&
            response.data !== null &&
            response.data !== undefined
          ) {
            data = response.data;
          }

          console.log('Data used for Sentry:', data);

          // =====================================================
          // PROJECT NAME
          // =====================================================

          this.projectNameForSentry = '';

          if (data.projectName) {
            this.projectNameForSentry = data.projectName;
          } else if (data.name) {
            this.projectNameForSentry = data.name;
          }

          // =====================================================
          // COUNTRY VALUE
          // =====================================================

          let countryValue = '';

          if (data.locationCodes) {
            countryValue = data.locationCodes;
          } else if (data.LocationCodes) {
            countryValue = data.LocationCodes;
          } else if (data.countryCodes) {
            countryValue = data.countryCodes;
          } else if (data.countryCode) {
            countryValue = data.countryCode;
          } else if (
            data.country !== null &&
            data.country !== undefined &&
            data.country.code
          ) {
            countryValue = data.country.code;
          }

          console.log('RAW COUNTRY VALUE:', countryValue);

          // =====================================================
          // CONVERT COUNTRY VALUE TO ARRAY
          // "AU,IN" => ["AU", "IN"]
          // =====================================================

          let countryCodes: string[] = [];

          if (Array.isArray(countryValue)) {

            for (let i = 0; i < countryValue.length; i++) {

              const value = String(countryValue[i]);

              const values = value.split(',');

              for (let j = 0; j < values.length; j++) {

                const code = values[j].trim();

                if (code !== '') {
                  countryCodes.push(code);
                }
              }
            }

          } else {

            const values = String(countryValue).split(',');

            for (let i = 0; i < values.length; i++) {

              const code = values[i].trim();

              if (code !== '') {
                countryCodes.push(code);
              }
            }
          }

          console.log('COUNTRY CODES:', countryCodes);

          // =====================================================
          // SELECT COUNTRIES
          // =====================================================

          this.countryForSentry = [];

          if (
            this.data !== null &&
            this.data !== undefined &&
            this.data.length > 0
          ) {

            for (let i = 0; i < this.data.length; i++) {

              const country = this.data[i];

              if (
                country !== null &&
                country !== undefined &&
                country.code !== null &&
                country.code !== undefined
              ) {

                const dropdownCode =
                  String(country.code)
                    .trim()
                    .toLowerCase();

                for (let j = 0; j < countryCodes.length; j++) {

                  const apiCode =
                    String(countryCodes[j])
                      .trim()
                      .toLowerCase();

                  if (dropdownCode === apiCode) {

                    this.countryForSentry.push(country);

                    break;
                  }
                }
              }
            }
          }

          console.log(
            'FINAL SELECTED COUNTRIES:',
            this.countryForSentry
          );

          // =====================================================
          // LANGUAGE VALUE
          // =====================================================

          let languageValue = '';

          if (data.languageCodes) {
            languageValue = data.languageCodes;
          } else if (data.LanguageCodes) {
            languageValue = data.LanguageCodes;
          } else if (data.languageCode) {
            languageValue = data.languageCode;
          } else if (
            data.language !== null &&
            data.language !== undefined &&
            data.language.code
          ) {
            languageValue = data.language.code;
          }

          console.log('RAW LANGUAGE VALUE:', languageValue);

          // =====================================================
          // CONVERT LANGUAGE VALUE TO ARRAY
          // "en,hi" => ["en", "hi"]
          // =====================================================

          let languageCodes: string[] = [];

          if (Array.isArray(languageValue)) {

            for (let i = 0; i < languageValue.length; i++) {

              const value = String(languageValue[i]);

              const values = value.split(',');

              for (let j = 0; j < values.length; j++) {

                const code = values[j].trim();

                if (code !== '') {
                  languageCodes.push(code);
                }
              }
            }

          } else {

            const values = String(languageValue).split(',');

            for (let i = 0; i < values.length; i++) {

              const code = values[i].trim();

              if (code !== '') {
                languageCodes.push(code);
              }
            }
          }

          console.log('LANGUAGE CODES:', languageCodes);

          // =====================================================
          // SELECT LANGUAGES
          // =====================================================

          this.languageForSentry = [];

          if (
            this.dataL !== null &&
            this.dataL !== undefined &&
            this.dataL.length > 0
          ) {

            for (let i = 0; i < this.dataL.length; i++) {

              const language = this.dataL[i];

              if (
                language !== null &&
                language !== undefined &&
                language.code !== null &&
                language.code !== undefined
              ) {

                const dropdownCode =
                  String(language.code)
                    .trim()
                    .toLowerCase();

                for (let j = 0; j < languageCodes.length; j++) {

                  const apiCode =
                    String(languageCodes[j])
                      .trim()
                      .toLowerCase();

                  if (dropdownCode === apiCode) {

                    this.languageForSentry.push(language);

                    break;
                  }
                }
              }
            }
          }

          console.log(
            'FINAL SELECTED LANGUAGES:',
            this.languageForSentry
          );

          // =====================================================
          // OTHER SENTRY FIELDS
          // =====================================================

          this.assignedClipForSentry = '';

          if (rowData.assignedClip) {
            this.assignedClipForSentry = rowData.assignedClip;
          }

          this.protectIdForSentry = '';

          if (rowData.projectId) {
            this.protectIdForSentry = rowData.projectId;
          }

          this.VendorNameForSentry = '';

          if (rowData.vendorName) {
            this.VendorNameForSentry = rowData.vendorName;
          }

          this.VendorIdForSentry = '';

          if (rowData.vendorId) {
            this.VendorIdForSentry = rowData.vendorId;
          }

          // =====================================================
          // EXEVO LINK
          // =====================================================

          let link = '';

          if (rowData.exevoLink) {
            link = rowData.exevoLink;
          }

          if (link !== '') {
            this.exevoLinkForSentry =
              link.replace(
                /\[RE\]/g,
                'SENTRY_RESPONDENT_ID'
              );
          } else {
            this.exevoLinkForSentry = '';
          }

          // =====================================================
          // OPEN MODAL
          // =====================================================

          $('#sentryAPIModal').show();
        },

        error: (error: any) => {

          console.error(
            'GetDataForSentryApi HTTP error:',
            error
          );

          console.error(
            'Row data:',
            rowData
          );
        }
      });
  }

  createSentryProject() {

    if (!this.projectNameForSentry) {
      alert('Please enter project name.');
      return;
    }

    if (!this.selectedTemplateId) {
      alert('Please select a template.');
      return;
    }

    // if (!this.countryForSentry) {
    //   alert('Please select country.');
    //   return;
    // }

    // if (!this.languageForSentry) {
    //   alert('Please select language.');
    //   return;
    // }

    // Validate country
    if (!this.countryForSentry || this.countryForSentry.length === 0) {
      alert('Please select at least one country.');
      return;
    }

    // Validate language
    if (!this.languageForSentry || this.languageForSentry.length === 0) {
      alert('Please select at least one language.');
      return;
    }

    this.userService.CheckVendorProviderExists(
      this.VendorNameForSentry.trim()
    ).subscribe(
      (res: string) => {

        debugger;
        console.log('CheckVendorProviderExists response:', res);

        // Stop everything if ProviderId does not exist
        if (res == null || res.trim() === '') {
          alert('ProviderId does not exist.');
          return;
        }

        // ProviderId exists
        console.log('ProviderId:', res);

        const request = {
          assignedClip: this.assignedClipForSentry,
          petProtectId: this.protectIdForSentry,
          vendorName: this.VendorNameForSentry,
          vendorId: this.VendorIdForSentry,

          name: this.projectNameForSentry,
          clientUrl: this.exevoLinkForSentry,
          templateId: this.selectedTemplateId,

          // Change this if clientName should come from another field
          clientName: this.projectNameForSentry,

          notes: '',

          // languageCodes: [
          //   this.languageForSentry
          // ],

          // locationCodes: [
          //   this.countryForSentry
          // ],

          // Send selected language codes
          languageCodes: this.languageForSentry.map(
            (language: any) => language.code
          ),

          // Send selected country codes
          locationCodes: this.countryForSentry.map(
            (country: any) => country.code
          ),

          locationType: 'Allow',

          terminationUrl: this.sentryTerminationURL,
          testClientUrl: '',

          addStatusToUrl: this.addSentryStatusToUrl,
          dontForwardQueryVariables: true,
          skipQuestions: false,

          verisoulProjectSettings: {
            isEnabled: this.enableVerisoul,
            shouldTermFake: this.fakeRespondentsAction === 'Term',
            shouldTermSuspicious: this.suspiciousRespondentsAction === 'Term'
          },

          ignoreSettings: {
            ignoreRecaptchaGrade: false,
            ignoreSecurityChecks: false,
            ignoreTranslationChecks: false,
            ignoreQuestionGrade: false,
            ignoreDigitalFingerprintChecks: false
          }
        };

        console.log('Sentry Create Project Request:', request);

        this.userService.CreateSentryProject(request).subscribe(
          (res: any) => {
            debugger;
            console.log('CreateSentryProject response:', res);

            if (res.success === true) {

              this.toastr.success(res.message, '', { progressBar: true });
              this.closeSentryAPIDialog();

            } else {

              alert(
                res && res.message
                  ? res.message
                  : 'Unable to create Sentry project.'
              );
            }
          },

          (err: any) => {

            console.log('CreateSentryProject error:', err);

            var message = 'Unable to create Sentry project.';

            if (err && err.error && err.error.message) {

              message = err.error.message;

            } else if (
              err &&
              typeof err.error === 'string'
            ) {

              try {

                var parsed = JSON.parse(err.error);

                if (parsed && parsed.message) {
                  message = parsed.message;
                } else {
                  message = err.error;
                }

              } catch (e) {

                message = err.error;
              }

            } else if (err && err.message) {

              message = err.message;
            }

            alert(message);
          }
        );
      }
    );
  }

  updateSentryProject() {
    debugger;
    console.log('Update Sentry Project button clicked');

    if (!this.sentryExistingProjectId || !this.sentryExistingProjectId.trim()) {
      this.toastr.error(
        'Sentry Project ID is missing.',
        'Validation'
      );
      return;
    }

    if (!this.projectNameForSentry || !this.projectNameForSentry.trim()) {
      this.toastr.error(
        'Please enter project name.',
        'Validation'
      );
      return;
    }

    if (!this.selectedTemplateId) {
      this.toastr.error(
        'Please select a template.',
        'Validation'
      );
      return;
    }

    if (!this.countryForSentry) {
      this.toastr.error(
        'Please select country.',
        'Validation'
      );
      return;
    }

    if (!this.languageForSentry) {
      this.toastr.error(
        'Please select language.',
        'Validation'
      );
      return;
    }


    // ============================================================
    // 6. Convert selected Country objects to country codes
    //
    // Example:
    // [
    //   { code: 'AU', countryName: 'Australia' },
    //   { code: 'IN', countryName: 'India' }
    // ]
    //
    // becomes:
    // ['AU', 'IN']
    // ============================================================

    const locationCodes: string[] = this.countryForSentry
      .map((country: any) => country.code)
      .filter((code: string) =>
        code !== null &&
        code !== undefined &&
        code.trim() !== ''
      )
      .map((code: string) => code.trim());

    // ============================================================
    // 7. Convert selected Language objects to language codes
    //
    // Example:
    // [
    //   { code: 'en', language: 'English' },
    //   { code: 'hi', language: 'Hindi' }
    // ]
    //
    // becomes:
    // ['en', 'hi']
    // ============================================================

    const languageCodes: string[] = this.languageForSentry
      .map((language: any) => language.code)
      .filter((code: string) =>
        code !== null &&
        code !== undefined &&
        code.trim() !== ''
      )
      .map((code: string) => code.trim());

    // ============================================================
    // 8. Validate converted Country codes
    // ============================================================

    if (locationCodes.length === 0) {
      alert('Please select at least one valid country.');
      return;
    }

    // ============================================================
    // 9. Validate converted Language codes
    // ============================================================

    if (languageCodes.length === 0) {
      alert('Please select at least one valid language.');
      return;
    }

    // ============================================================
    // 10. Remove duplicate Country codes
    // ============================================================

    const uniqueLocationCodes: string[] = [];

    locationCodes.forEach((code: string) => {
      if (uniqueLocationCodes.indexOf(code) === -1) {
        uniqueLocationCodes.push(code);
      }
    });

    // ============================================================
    // 11. Remove duplicate Language codes
    // ============================================================

    const uniqueLanguageCodes: string[] = [];

    languageCodes.forEach((code: string) => {
      if (uniqueLanguageCodes.indexOf(code) === -1) {
        uniqueLanguageCodes.push(code);
      }
    });



    const request = {
      name: this.projectNameForSentry,
      clientUrl: this.exevoLinkForSentry,
      templateId: this.selectedTemplateId,
      clientName: this.projectNameForSentry,
      notes: '',
      // languageCodes: [this.languageForSentry],
      // locationCodes: [this.countryForSentry],

      // IMPORTANT:
      // Send arrays of codes to backend
      languageCodes: uniqueLanguageCodes,
      locationCodes: uniqueLocationCodes,

      locationType: 'Allow',
      terminationUrl: this.sentryTerminationURL,
      testClientUrl: '',
      addStatusToUrl: this.addSentryStatusToUrl,
      dontForwardQueryVariables: true,
      skipQuestions: false,

      verisoulProjectSettings: {
        isEnabled: this.enableVerisoul,
        shouldTermFake: this.fakeRespondentsAction === 'Term',
        shouldTermSuspicious: this.suspiciousRespondentsAction === 'Term'
      },

      ignoreSettings: {
        ignoreRecaptchaGrade: false,
        ignoreSecurityChecks: false,
        ignoreTranslationChecks: false,
        ignoreQuestionGrade: false,
        ignoreDigitalFingerprintChecks: false
      }
    };

    console.log('Sentry Update Project Request:', request);
    console.log('Sentry Project ID:', this.sentryExistingProjectId);

    this.userService.UpdateSentryProject(this.sentryExistingProjectId, request)
      .subscribe({
        next: (response: any) => {
          debugger;
          console.log(
            'Sentry project updated successfully:',
            response
          );

          if (response.success) {
            // this.sentryProjectData = response.project;
            // this.toastr.success(
            //   'Sentry project updated successfully.',
            //   'Success'
            // );
            this.toastr.success(response.message, '', { progressBar: true });
            this.closeSentryAPIDialog();

          } else {
            // this.toastr.error(
            //   response.message ||
            //   'Unable to update Sentry project.',
            //   'Error'
            // );
            this.toastr.error('Unable to update Sentry project.', '', { progressBar: true });
          }
        },

        error: (error: any) => {
          console.log(
            'Error updating Sentry project:',
            error
          );

          const message =
            error.error.message ||
            'Unable to update Sentry project.';

          // this.toastr.error(message, 'Error');
          this.toastr.error(message, '', { progressBar: true });
          this.closeSentryAPIDialog();
        }
      });
  }

  /* ==============================
Verisoul Settings
============================== */

  enableVerisoul: boolean = false;

  fakeRespondentsAction: string = 'Term';

  suspiciousRespondentsAction: string = 'Term';

  /* ==============================
  Verisoul Toggle
  ============================== */

  onVerisoulToggle(): void {

    // When Verisoul is enabled,
    // reset both dropdowns to Term.
    if (this.enableVerisoul === true) {

      this.fakeRespondentsAction = 'Term';

      this.suspiciousRespondentsAction = 'Term';

    }

  }

  /* ==============================
  Get Verisoul Data
  ============================== */

  getVerisoulData(): any {

    return {

      enableVerisoul: this.enableVerisoul,

      fakeRespondentsAction: this.fakeRespondentsAction,

      suspiciousRespondentsAction: this.suspiciousRespondentsAction,

      fakeRespondentsTerm:
        this.enableVerisoul === true &&
        this.fakeRespondentsAction === 'Term',

      suspiciousRespondentsTerm:
        this.enableVerisoul === true &&
        this.suspiciousRespondentsAction === 'Term'

    };

  }



  /* ============================================
  Add Sentry Status to URL
  ============================================ */

  addSentryStatusToUrl: boolean = false;

  /* ============================================
  Sentry Status Toggle
  ============================================ */

  onSentryStatusToggle(): void {

    if (this.addSentryStatusToUrl === true) {

      // Toggle is ON
      this.addSentryStatusToUrl = true;

      console.log('Add Sentry Status to URL: ON');

    } else {

      // Toggle is OFF
      this.addSentryStatusToUrl = false;

      console.log('Add Sentry Status to URL: OFF');

    }

  }

  /* ============================================
  Get Sentry Status Value
  ============================================ */

  getSentryStatusData(): any {

    return {
      addSentryStatusToUrl: this.addSentryStatusToUrl
    };

  }




  ResetData(params) {
    debugger;
    if (!this.multipleBool) {
      this.isDataLoading = true;
      this.userService.ResetData(params.data, this.roleId).subscribe(
        (data) => {
          this.isDataLoading = false;
          if (data == true) {
            this.toastr.success("Data Reset Successfully", '', { progressBar: true });
          }
          else {
            this.toastr.warning("Some Error Occurred", '', { progressBar: true });
          }
        }
      )
    }
    else if (this.multipleBool) {
      this.isDataLoading = true;
      this.userService.ResetDataForMultiple(params.data, this.roleId).subscribe(
        (data) => {
          this.isDataLoading = false;
          if (data == true) {
            this.toastr.success("Data Reset Successfully", '', { progressBar: true });
          }
          else {
            this.toastr.warning("Some Error Occurred", '', { progressBar: true });
          }
        }
      )
    }
  }

  editCountryCheck(param) {
    this.userService.editcountrychecks(param.data.projectId, param.data.countryId, param.data.languageId)
      .subscribe((data: any) => {
        if (data != null && data != undefined) {
          console.log("data:", data);
          this.project.ipsecurity = data.isIPEnabled;
          this.project.custompage = data.isCustomPageEnabled;
          this.project.geoiplocation = data.isGeoIPLocationEnabled;
          this.project.fingerprintsecurity = data.isFingerPrintEnabled;
          this.project.questionnaire = data.questionnaire;
          this.project.recaptcha = data.recaptcha;
          this.project.mobile = data.mobile;
          this.project.projectid = data.projectId;
          this.project.languageid = data.langid;
          this.project.countryid = data.countryid;
          this.project.isActiveLocalTimeZone = data.isActiveLocalTimeZone;
          //this.project.invisiblerecaptcha = data[0].invisiblerecaptcha;
          this.project.waitingTime = data.waitingTime;
          // let [hour, minute, period] = data.openStartTime.split(":").join(" ").split(" ");
          // let [Chour, Cminute, Cperiod] = data.openCloseTime.split(":").join(" ").split(" ");
          // hour = parseInt(hour, 10).toString();
          // Chour = parseInt(Chour, 10).toString();

          let [hour, minute, period] = data.openStartTime
            ? data.openStartTime.split(":").join(" ").split(" ")
            : ["", "", ""];

          let [Chour, Cminute, Cperiod] = data.openCloseTime
            ? data.openCloseTime.split(":").join(" ").split(" ")
            : ["", "", ""];

          hour = hour ? parseInt(hour, 10).toString() : "";
          Chour = Chour ? parseInt(Chour, 10).toString() : "";

          this.project.selectedFromHour = hour;
          this.project.selectedFromMinute = minute;
          this.project.selectedFromAmpm = period;

          this.project.selectedToHour = Chour;
          this.project.selectedToMinute = Cminute;
          this.project.selectedToAmpm = Cperiod;
          //console.log("Project",this.project);
        }
      });
    $("#myModal").show();
  }

  onButtonCloseSentryAPIDialog() {
    $("#sentryAPIModal").hide();
  }

   closeSentryAPIDialog(): void {
  $("#sentryAPIModal").hide();

  setTimeout(() => {
    window.location.reload();
  }, 2000);
}

// closeSentryAPIDialog(): void {
//   $("#sentryAPIModal").hide();

//   const toast = this.toastr.success(
//     'Sentry project dialog closed successfully.',
//     'Success',
//     {
//       timeOut: 1000,
//       closeButton: true,
//       progressBar: true
//     }
//   );

//   if (toast) {
//     toast.onHidden.subscribe(() => {
//       window.location.reload();
//     });
//   }
// }

  closeDialog() {
    $("#myModal").hide();
  }

  OnSubmit(form: NgForm) {
    debugger;
    form.value.projectid = this.roleId;
    form.value.teamMember = Array.isArray(this.project.teamMember) ? this.project.teamMember.map((member: any) => member.id) : [''];
    console.log(form.value);
    if (form.value.projectMode == "1") {
      form.value.projectMode = "Staging";
    }
    else if (form.value.projectMode == "2") {
      form.value.projectMode = "Production";
    }
    else if (form.value.projectMode == "3") {
      form.value.projectMode = "Fieldwork Closed";
    }

    this.userService.updateProjectStatus(form.value)
      .subscribe((data: any) => {
        if (data != null && data != undefined) {
          this.userService.updateProjectLog(form.value)
            .subscribe((data: any) => {
            });
          this.toastr.success("Project Status Updated", '', { progressBar: true });
        }
      });
  }

  EditCountryCheck() {
    console.log("After edit", this.project);
    this.userService.updateCountryCheck(this.project)
      .subscribe((data: any) => {
        if (data) {
          this.toastr.success("Checks Updated Successfully", '', { progressBar: true });
          this.closeDialog();
        }
        else {
          this.toastr.error("Error Occurred", '', { progressBar: true });
          this.closeDialog();
        }
      });
  }

  exportLinksMultiple(param) {
    debugger
    this.userService.getMultipleLinkDataToExport(param.data, this.roleId)
      .subscribe((data: any) => {
        if (data) {
          this.DownloadExcel(data);
        }
        else {
          this.toastr.error("No Data To Export", '', { progressBar: true });
        }
      });
  }

  DownloadExcel(data: any) {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data']
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, "Multiple_Links");
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    fileSaver.saveAs(data, `${fileName}_export_${new Date().getTime()}${EXCEL_EXTENSION}`);
  }

}

